import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Summer/PositionAndDirection/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [6, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/1DescribeTurns" */ './1DescribeTurns'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/2DescribePositionLeftAndRight" */ './2DescribePositionLeftAndRight'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/3DescribePositionForwardsAndBackwards" */ './3DescribePositionForwardsAndBackwards'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/4DescribePositionAboveAndBelow" */ './4DescribePositionAboveAndBelow'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/5OrdinalNumbers" */ './5OrdinalNumbers'
        )
    })
  ]
});
export default Block;
